import React from "react";
import { Page } from "../Page";
import { api } from "../../api/api";
import { script } from "../../types";
import { Table } from "../../core/ui/Table";
import { ConditionalController, useConditional } from "../../core/hooks/useConditional";
import { Modal } from "../../core/ui/Modal";
import { DataContext, useDataContext } from "../../core/hooks/useData";
import { Text } from "../../core/form/Text";
import { EditableTable } from "../../core/ui/EditableTable";
import { CheckboxCol, IDCol, LastUpdatedCol, SyncTableCol, TitleCol, VersionCol } from "../../layout/TableCells";
import { newID } from "../../core/utils/unique";
import { FormModal } from "../../data-entry/FormModal";
import { JSEditor } from "../../core/ui/JSEditor";
import { useBulkActions } from "../../core/hooks/useBulkActions";
import { DuplicateModal } from "../../core/ui/DuplicateModal";


export function EditModal(props: {
	item: script,
	controller: ConditionalController<any>,

	onSave: () => void,
	onDelete: () => void,
}) {

	const data = useDataContext({ initialValue: props.item });

	return (
		<DataContext.Provider value={data}>
			<Modal
				title="Edit Script"

				editableTitle={{
					obj: props.item,
					prop: "title",
				}}
				editableSubtitle={{
					obj: props.item,
					prop: "id",
				}}

				onCancel={props.controller.close}
				onSave={props.onSave}
				saveOnEnterKey={false}
				showDelete={true}
				onDelete={props.onDelete}
			>

				<JSEditor
					object={props.item}
					prop="script"
				/>

			</Modal>
		</DataContext.Provider>
	)

}


export function Scripts(props: {

}) {

	const [scripts, setScripts] = React.useState<script[]>();
	const [token, setToken] = React.useState("");

	React.useEffect(() => {
		api.script_get({}).then((scripts: script[]) => {
			scripts.sort((a, b) => {
				return (a ? a.title : "").localeCompare(b ? b.title : "");
			});

			setScripts(scripts as script[]);

		}).catch(() => {

		});
	}, [token]);

	const duplicateModal = useConditional((item: script) => {
		return (
			<DuplicateModal
				item={item}
				onDuplicate={(item, newId) => {
					return api.script_post({
						...item,
						id: newId,
						title: (item.title || "") + " (Copy)",
					}).then(() => {
						bulk.selection.clear();
						setToken(newID());
					});
				}}
				onClose={() => duplicateModal.close()}
			/>
		);
	});

	const bulk = useBulkActions<script>({
		items: scripts || [],
		onDelete: (items) => {
			return Promise.all(items.map(item => api.script_delete(item))).then(() => {
				setToken(newID());
			});
		},
		onDuplicate: (item) => {
			duplicateModal.show(item);
		},
	});

	const edit = useConditional((s: script) => {
		return (
			<EditModal
				item={s}
				controller={edit}

				onSave={() => {
					api.script_post(s).then((result: any) => {
						if (result.id && !s.id) s.id = result.id;

						edit.close();
					}).catch(() => {

					});
				}}
				onDelete={() => {
					api.script_delete(s).then((result: any) => {
						if (scripts) {
							const items = scripts.slice(0);
							for(let i=0;i<items.length;i++) {
								if (items[i] === s) {
									items.splice(i, 1);
									setScripts(items);
									break;
								}
							}
						}

						edit.close();
					}).catch(() => {

					});
				}}
			/>
		)
	});

	const createModal = useConditional(() => {
		return (
			<FormModal
				title="Create Script"
				form="script-create"
				onCancel={createModal.close}
				onSave={(value: script) => {

					const r = {
						...value,
						deleted: 0,

						script: "",
					}

					api.script_post(r).then(() => {
						setToken(newID());
						createModal.close();
					}).catch(() => {

					});
				}}
			/>
		)
	});

	if (!scripts) {
		return null;
	}

	return (
		<Page
			compact={true}
			title={{
				text: "Scripts",
				icon: "code_color",
				buttons: [
					{ title: "Create" }
				]
			}}
			onButton={(btn) => {
				createModal.show({});
			}}
		>

			<Table
				interactive={true}
				cols={[
					CheckboxCol({ selection: bulk.selection, items: scripts }),
					VersionCol(),
					IDCol(),
					TitleCol(),
					LastUpdatedCol(),
					SyncTableCol({ container: "script", onSync: () => {
						setToken(newID());
					} }),
				]}
				items={scripts}
				onClick={(e, r) => {
					if (r) {
						edit.show(r);
					}
				}}
				bulkActions={bulk.bulkActions}
				onBulkAction={bulk.onBulkAction}
			/>

			{edit.render()}
			{createModal.render()}
			{duplicateModal.render()}

		</Page>
	);
}